

$(document).ready(function(){
  $('.site-nav__thumb-button.js-toggle-slide-nav').click(function(){
    $('.slide-nav__overflow').addClass('open-menu');
  });
  $('.sidenav-close.close-class').click(function(){
    $('.slide-nav__overflow').removeClass('open-menu');
    $('.slide-nav__item').removeClass('open-dropdown');
    $('#SlideNav .slide-nav__item.true .megamenu-sub-option').hide();
    $('#SlideNav .slide-nav__item .site-nav__link').show();
    $('.slide-nav__overflow').removeClass('open-main-dropdown');
  });
  $('.slide-nav__item').children('.megamenu-sub-option').parents('.slide-nav__item').addClass('true');

  $('#SlideNav .slide-nav__item.true .megamenu-sub-option').hide();
  $('#SlideNav .slide-nav__item.true .site-nav__link').click(function(e){
    $('.slide-nav__item').removeClass('open-dropdown');
    $(this).parents('.slide-nav__item').find('.megamenu-sub-option').show();
    $(this).parents('.slide-nav__item').addClass('open-dropdown');
    $(this).parents('.slide-nav__overflow').addClass('open-main-dropdown');
    $('.slide-nav .site-nav__link').hide();

  });

  $('.back').click(function(){
    $('.site-nav__link').show();
    $(this).parents('.slide-nav__overflow').find('.megamenu-sub-option').hide();
    $(this).parents('.slide-nav__overflow').removeClass('open-main-dropdown');
  });

  $('.child-back').click(function(){
    $('.sub-menu').removeClass('active-submenu');
  });

  $('.megamenu-sub-menu .megamenu-desc .sub-menu .main-heading').click(function(){
    $('.slide-nav__overflow.open-main-dropdown .slide-back-close .back').hide();
  });

  $('.megamenu-sub-allsub .megamenu-desc .sub-menu .child .child-back').click(function(){
    $('.slide-nav__overflow.open-main-dropdown .slide-back-close .back').show();
  });

  $('.site-nav.site-navigation .site-nav__item').hover(function(){
    $('.site-nav .site-nav__item .megamenu-sub-option').toggleClass('submenu-active');
    $('body').toggleClass('megamenu-bg');
  });

  $('.site-nav.site-navigation .site-nav__item.about').hover(function(){
    $('.site-nav .site-nav__item .megamenu-sub-option').toggleClass('submenu-active');
    $('body').removeClass('megamenu-bg');
  });

  $('.header-menu-mobile').click(function(){
  	$('body').addClass('mobile-menu-hidden');
  });

  $('.slide-back-close').click(function(){
  	$('body').removeClass('mobile-menu-hidden');
  });
  
  $('.header-item .site-nav.site-navigation .site-nav__item').hover(function(){
  	$('.site-header').toggleClass('header-color-cng');
  });
  
  $('.header-item .site-nav.site-navigation .site-nav__item.about').hover(function(){
  	$('.site-header').removeClass('header-color-cng');
  });
  
  
  
  $('.slick-slider-product-page').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows:false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });


  if($(window).width() <= 480){
    $('.collections-products .product-slider').mouseenter(function(){
      $(this).slick({
        dots: false,
        draggable:true,
        infinite: true,
        autoplay: true,
        fade:true,
        autoplaySpeed: 1000,
        cssEase: 'linear',
        speed: 300,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    });
    $('.collections-products .product-slider').mouseleave(function(){
      $(this).slick('unslick');
    });
  }
  
  
  $('button.add-to-cart').click(function(){
    $('.header-wrapper').removeClass('isnt-active');
    $('.header-wrapper').addClass('is-active');
//     var scroll_val = $(window).scrollTop();
//     scroll_val = scroll_val - 50;
//   	 $("html, body").animate({ scrollTop: scroll_val }, '600'); 
  });

$(".logo-list").slick({speed:3e3,autoplay:!0,autoplaySpeed:0,draggable: false,cssEase:"linear",slidesToShow:5,slidesToScroll:1,infinite:!0,swipeToSlide:!0,centerMode:!0,focusOnSelect:!0,arrows:!1,variableWidth:!0});

  $('.logo-list-reverse').slick({
    speed: 3e3,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide:true,
    variableWidth:false,
    arrows:false,
    dots: false,
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: false,
    pauseOnHover:false,
    draggable: false,
    rtl: true,
    responsive: [
      {
        breakpoint: 1651,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '50px',
          autoplaySpeed: 90
        }
      }
    ]
  });
  
  $(".winepackage-scrollingtxt .marquee__text").slick({speed:3e3,autoplay:!0,autoplaySpeed:0,draggable: false,cssEase:"linear",slidesToShow:4,slidesToScroll:1,infinite:!0,swipeToSlide:!0,centerMode:!0,focusOnSelect:false,arrows:!1,variableWidth:!0});
 

  $('.feature-collections .collections-products').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: false,
    infinite: false,
    centerPadding: '-40px',
    speed: 300,
    draggable:true,
    arrows:true,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="57px" height="57px" viewBox="0 0 57 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Group 23 Copy 2</title> <g id="Current-Design---Product-Card-and-Slider" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Product_Slider" transform="translate(-1700.000000, -745.000000)"> <g id="Group-5" transform="translate(375.000000, 373.000000)"> <g id="Group-8" transform="translate(1353.500000, 400.500000) scale(-1, 1) translate(-1353.500000, -400.500000) translate(1326.000000, 373.000000)"> <circle id="Oval" stroke="#1C1B1B" stroke-width="2" fill="#FFFFFF" cx="27.5" cy="27.5" r="27.5"></circle> <path d="M25.4858529,18 L33.607,26.454 L33.6252582,26.4354231 L35.1111111,27.9809517 L35.092,28 L35.1111111,28.0190483 L33.6252582,29.5645769 L33.607,29.545 L25.4858529,38 L24,36.4544714 L32.122,27.999 L24,19.5455286 L25.4858529,18 Z" id="Combined-Shape-Copy" fill="#1C1B1B" transform="translate(29.555556, 28.000000) rotate(-360.000000) translate(-29.555556, -28.000000) "></path> </g> </g> </g> </g> </svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="57px" height="57px" viewBox="0 0 57 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Group 23 Copy 2</title> <g id="Current-Design---Product-Card-and-Slider" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Product_Slider" transform="translate(-1700.000000, -745.000000)"> <g id="Group-5" transform="translate(375.000000, 373.000000)"> <g id="Group-8" transform="translate(1326.000000, 373.000000)"> <circle id="Oval" stroke="#1C1B1B" stroke-width="2" fill="#FFFFFF" cx="27.5" cy="27.5" r="27.5"></circle> <path d="M25.4858529,18 L33.607,26.454 L33.6252582,26.4354231 L35.1111111,27.9809517 L35.092,28 L35.1111111,28.0190483 L33.6252582,29.5645769 L33.607,29.545 L25.4858529,38 L24,36.4544714 L32.122,27.999 L24,19.5455286 L25.4858529,18 Z" id="Combined-Shape-Copy" fill="#1C1B1B" transform="translate(29.555556, 28.000000) rotate(-360.000000) translate(-29.555556, -28.000000) "></path> </g> </g> </g> </g> </svg></button>',
    //centerMode: true,

    responsive: [
      {
        breakpoint: 1601,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          draggable:true,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
          centerPadding: '90px',
          centerMode: true
        }
      }
    ]
  });    

  $('.testimonials-section .testimonials').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows:false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 798,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  $('.winemaker-section .winemaker').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 10,
    fade: !0,
    draggable:true,
    arrows:true,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="57px" height="57px" viewBox="0 0 57 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Group 23 Copy 2</title> <g id="Current-Design---Product-Card-and-Slider" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Product_Slider" transform="translate(-1700.000000, -745.000000)"> <g id="Group-5" transform="translate(375.000000, 373.000000)"> <g id="Group-8" transform="translate(1353.500000, 400.500000) scale(-1, 1) translate(-1353.500000, -400.500000) translate(1326.000000, 373.000000)"> <circle id="Oval" stroke="#1C1B1B" stroke-width="2" fill="#FFFFFF" cx="27.5" cy="27.5" r="27.5"></circle> <path d="M25.4858529,18 L33.607,26.454 L33.6252582,26.4354231 L35.1111111,27.9809517 L35.092,28 L35.1111111,28.0190483 L33.6252582,29.5645769 L33.607,29.545 L25.4858529,38 L24,36.4544714 L32.122,27.999 L24,19.5455286 L25.4858529,18 Z" id="Combined-Shape-Copy" fill="#1C1B1B" transform="translate(29.555556, 28.000000) rotate(-360.000000) translate(-29.555556, -28.000000) "></path> </g> </g> </g> </g> </svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="57px" height="57px" viewBox="0 0 57 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Group 23 Copy 2</title> <g id="Current-Design---Product-Card-and-Slider" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Product_Slider" transform="translate(-1700.000000, -745.000000)"> <g id="Group-5" transform="translate(375.000000, 373.000000)"> <g id="Group-8" transform="translate(1326.000000, 373.000000)"> <circle id="Oval" stroke="#1C1B1B" stroke-width="2" fill="#FFFFFF" cx="27.5" cy="27.5" r="27.5"></circle> <path d="M25.4858529,18 L33.607,26.454 L33.6252582,26.4354231 L35.1111111,27.9809517 L35.092,28 L35.1111111,28.0190483 L33.6252582,29.5645769 L33.607,29.545 L25.4858529,38 L24,36.4544714 L32.122,27.999 L24,19.5455286 L25.4858529,18 Z" id="Combined-Shape-Copy" fill="#1C1B1B" transform="translate(29.555556, 28.000000) rotate(-360.000000) translate(-29.555556, -28.000000) "></path> </g> </g> </g> </g> </svg></button>',
  });



  $(window).scroll(function(){
    if(jQuery(window).width() >= 768){
      if ($(this).scrollTop() > 1000) {
        $(".productBottom").addClass("show");
      } else { 
        $(".productBottom").removeClass("show");
      } 
    }
    else{
      if ($(this).scrollTop() > 1500) {
        $(".productBottom").addClass("show");
      } else { 
        $(".productBottom").removeClass("show");
      }
    }
  });


  // list-collection-catagoery-scroll

  $(".category-content").click(function() {
    var btn_click = $(this).attr('data-collection-handle');
    console.log(btn_click);
    $('html,body').animate({
      scrollTop: $('.feature-collections-headings[data-collection="'+btn_click+'"]').offset().top-150},
                           'slow');
  });
});

$('.grid-product__title').mouseenter(function(){
  $(this).parents('.grid-product__content').addClass('product-title-hvr');
});
$('.grid-product__title').mouseleave(function(){
  $(this).parents('.grid-product__content').removeClass('product-title-hvr');
});


setTimeout(function(){ 
  $('.collection-logo-slide .collection-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: false,
    infinite: false,
    centerPadding: '-40px',
    speed: 600,
    arrows:true,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="57px" height="57px" viewBox="0 0 57 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Group 23 Copy 2</title> <g id="Current-Design---Product-Card-and-Slider" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Product_Slider" transform="translate(-1700.000000, -745.000000)"> <g id="Group-5" transform="translate(375.000000, 373.000000)"> <g id="Group-8" transform="translate(1353.500000, 400.500000) scale(-1, 1) translate(-1353.500000, -400.500000) translate(1326.000000, 373.000000)"> <circle id="Oval" stroke="#1C1B1B" stroke-width="2" fill="#FFFFFF" cx="27.5" cy="27.5" r="27.5"></circle> <path d="M25.4858529,18 L33.607,26.454 L33.6252582,26.4354231 L35.1111111,27.9809517 L35.092,28 L35.1111111,28.0190483 L33.6252582,29.5645769 L33.607,29.545 L25.4858529,38 L24,36.4544714 L32.122,27.999 L24,19.5455286 L25.4858529,18 Z" id="Combined-Shape-Copy" fill="#1C1B1B" transform="translate(29.555556, 28.000000) rotate(-360.000000) translate(-29.555556, -28.000000) "></path> </g> </g> </g> </g> </svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="57px" height="57px" viewBox="0 0 57 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Group 23 Copy 2</title> <g id="Current-Design---Product-Card-and-Slider" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Product_Slider" transform="translate(-1700.000000, -745.000000)"> <g id="Group-5" transform="translate(375.000000, 373.000000)"> <g id="Group-8" transform="translate(1326.000000, 373.000000)"> <circle id="Oval" stroke="#1C1B1B" stroke-width="2" fill="#FFFFFF" cx="27.5" cy="27.5" r="27.5"></circle> <path d="M25.4858529,18 L33.607,26.454 L33.6252582,26.4354231 L35.1111111,27.9809517 L35.092,28 L35.1111111,28.0190483 L33.6252582,29.5645769 L33.607,29.545 L25.4858529,38 L24,36.4544714 L32.122,27.999 L24,19.5455286 L25.4858529,18 Z" id="Combined-Shape-Copy" fill="#1C1B1B" transform="translate(29.555556, 28.000000) rotate(-360.000000) translate(-29.555556, -28.000000) "></path> </g> </g> </g> </g> </svg></button>',
    //     centerMode: true,

    responsive: [
      {
        breakpoint: 1401,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
}, 3000);

// Drag and scroll horizontal div
$(document).ready(function(){
  $('.column-image .collection_sec').mousedown(function (event) {
    $(this)
    .data('down', true)
    .data('x', event.clientX)
    .data('scrollLeft', this.scrollLeft)
    .addClass("dragging");

    return false;
  }).mouseup(function (event) {
    $(this)
    .data('down', false)
    .removeClass("dragging");
  }).mousemove(function (event) {
    if ($(this).data('down') == true) {
      this.scrollLeft = $(this).data('scrollLeft') + $(this).data('x') - event.clientX;
    }
  });
});
//   //Hide the Previous button.
//   $('.slick-prev').hide();

//   collectionslider.on('afterChange', function(event, slick, currentSlide) {
//   	//If we're on the first slide hide the Previous button and show the Next
//     if (currentSlide === 0) {
//       $('.slick-prev').hide();
//       $('.slick-next').show();
//     }
//     else {
//     	$('.slick-prev').show();
//     }

//     //If we're on the last slide hide the Next button.
//     if (slick.slideCount === currentSlide + 1) {
//     	$('.slick-next').hide();
//     }
//   });


// $(".megamenu-sub-option").css("display","none");
// $('.site-nav__item').hover(function(){
// $(this).find('.megamenu-sub-option').css("display","block");
// });
// $('.site-nav__item').mouseleave(function(){
// $(this).find('.megamenu-sub-option').css("display","none");
// });

$('.winemaker-nav').click(function(){ 
   $('.all_hide').hide();
    let nav_text = $(this).attr('data-text');
   $('.'+nav_text).show();
}); 

$('.home_image-text-with_collection_wrap ul').slick({
    dots: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite:false,
    arrows:true,
    rows:1,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="57px" height="57px" viewBox="0 0 57 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Group 23 Copy 2</title> <g id="Current-Design---Product-Card-and-Slider" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Product_Slider" transform="translate(-1700.000000, -745.000000)"> <g id="Group-5" transform="translate(375.000000, 373.000000)"> <g id="Group-8" transform="translate(1353.500000, 400.500000) scale(-1, 1) translate(-1353.500000, -400.500000) translate(1326.000000, 373.000000)"> <circle id="Oval" stroke="#1C1B1B" stroke-width="2" fill="#FFFFFF" cx="27.5" cy="27.5" r="27.5"></circle> <path d="M25.4858529,18 L33.607,26.454 L33.6252582,26.4354231 L35.1111111,27.9809517 L35.092,28 L35.1111111,28.0190483 L33.6252582,29.5645769 L33.607,29.545 L25.4858529,38 L24,36.4544714 L32.122,27.999 L24,19.5455286 L25.4858529,18 Z" id="Combined-Shape-Copy" fill="#1C1B1B" transform="translate(29.555556, 28.000000) rotate(-360.000000) translate(-29.555556, -28.000000) "></path> </g> </g> </g> </g> </svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="57px" height="57px" viewBox="0 0 57 57" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Group 23 Copy 2</title> <g id="Current-Design---Product-Card-and-Slider" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Product_Slider" transform="translate(-1700.000000, -745.000000)"> <g id="Group-5" transform="translate(375.000000, 373.000000)"> <g id="Group-8" transform="translate(1326.000000, 373.000000)"> <circle id="Oval" stroke="#1C1B1B" stroke-width="2" fill="#FFFFFF" cx="27.5" cy="27.5" r="27.5"></circle> <path d="M25.4858529,18 L33.607,26.454 L33.6252582,26.4354231 L35.1111111,27.9809517 L35.092,28 L35.1111111,28.0190483 L33.6252582,29.5645769 L33.607,29.545 L25.4858529,38 L24,36.4544714 L32.122,27.999 L24,19.5455286 L25.4858529,18 Z" id="Combined-Shape-Copy" fill="#1C1B1B" transform="translate(29.555556, 28.000000) rotate(-360.000000) translate(-29.555556, -28.000000) "></path> </g> </g> </g> </g> </svg></button>',
    responsive: [
      {
        breakpoint: 1327,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
});
$(document).ready(function(){
// Add smooth scrolling to all links
$("a").on('click', function(event) {
// Make sure this.hash has a value before overriding default behavior
if (this.hash !== "") {
// Prevent default anchor click behavior
event.preventDefault();
// Store hash
var hash = this.hash;
// Using jQuery's animate() method to add smooth page scroll
// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
$('html, body').animate({
scrollTop: $(hash).offset().top
}, 800, function(){
// Add hash (#) to URL when done scrolling (default click behavior)
window.location.hash = hash;
});
} // End if
});
});


$('.blog_nav_link').click(function(e){
  e.preventDefault();
  $('.main-blog .grid__item').hide();
  let nav = $(this).attr('data-nav-text');
  $('.'+nav).show();
});
$(document).ready(function(){
$('.all-buttons .add-to-cart').click(function(e){
  let product_id = $(this).attr('data-id');
  console.log(product_id);
  e.preventDefault();
 let formData = {
 'items': [{
  'id': product_id,
  'quantity': 1
  }]
};
   $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:formData,
          dataType: 'json',
          success: function (data) {
    document.dispatchEvent(new CustomEvent('cart:build'));
         // $('[data-cart-item-input-quantity]:eq(0)').trigger('input');
            $('body').trigger('updateCart');
          }
   });
  return false;  
});
});